export default __webpack_public_path__ + "static/media/EngineeringCanals_05.e46936bf.png";